import {DataStatus, openDialog} from 'platform/components';
import {Box, VStack} from 'platform/foundation';
import {match} from 'ts-pattern';

import {isEmpty} from 'ramda';

import {
  OAuthEmailCredentialsResponseBody,
  SmtpCredentialsResponseBody,
  useListEmailCredentialsQuery,
  useListEmailProviderQuery,
} from '@dms/api/core';
import {
  CreateEmailServiceProvider,
  SmtpCredentialsCard,
  isOAuthCredential,
  OAuthCredentialsCard,
  OAuthCredentialsDialogProvider,
} from '@dms/features/email-smtp';
import i18n from '@dms/i18n';

import {MyProfileTemplate} from '../../components/MyProfileTemplate/MyProfileTemplate';
import {DefaultMailboxSection} from './components/DefaultMailboxSection';

export function EmailServices() {
  const {isLoading: loadingEmailProviders, isError: errorEmailProviders} =
    useListEmailProviderQuery();

  const {
    data: emailCredentials,
    isLoading: loadingEmailCredentials,
    isError: errorEmailCredentials,
  } = useListEmailCredentialsQuery({ownerType: 'user'});

  const handleCreate = () =>
    openDialog(<CreateEmailServiceProvider ownerType="user" />, {
      title: i18n.t('page.integrations.labels.setupNewEmailService'),
    });

  const isLoading = loadingEmailCredentials || loadingEmailProviders;
  const isError = errorEmailCredentials || errorEmailProviders;

  return (
    <MyProfileTemplate
      isLoading={isLoading}
      isError={isError}
      header={{
        title: i18n.t('page.myProfile.labels.emailServices'),
        actions: [
          {
            type: 'button',
            title: i18n.t('general.labels.createNew'),
            onClick: handleCreate,
          },
        ],
        breadcrumbs: [
          {label: i18n.t('entity.user.labels.myProfile'), isCurrentPage: true},
          {label: i18n.t('page.myProfile.labels.emailServices'), isCurrentPage: true},
        ],
      }}
      data-testid="integrations-emailServices-settings"
    >
      <Box width={200}>
        <VStack spacing={6}>
          <DefaultMailboxSection data-testid="integrations-emailServices-settings" />
          <OAuthCredentialsDialogProvider credentials={emailCredentials} ownerType="user">
            <DataStatus
              spacing={10}
              isEmpty={isEmpty(emailCredentials?.credentials)}
              action={{
                title: i18n.t('general.labels.createNew'),
                onClick: handleCreate,
                leftIcon: 'content/add_circle',
              }}
            >
              <VStack spacing={4}>
                {emailCredentials?.credentials.map((credentials) =>
                  match(isOAuthCredential(credentials))
                    .with(true, () => (
                      <OAuthCredentialsCard
                        key={credentials.id}
                        credentials={credentials as OAuthEmailCredentialsResponseBody}
                        ownerType="user"
                      />
                    ))
                    .otherwise(() => (
                      <SmtpCredentialsCard
                        key={credentials.id}
                        credentials={credentials as SmtpCredentialsResponseBody}
                        ownerType="user"
                      />
                    ))
                )}
              </VStack>
            </DataStatus>
          </OAuthCredentialsDialogProvider>
        </VStack>
      </Box>
    </MyProfileTemplate>
  );
}
